var jquery = global.jQuery = global.$ = require('jquery');
var bootstrap = require('bootstrap');
var LazyLoad = require('vanilla-lazyload');
var rrssb = require('rrssb');
var stickykit = require('../node_modules/sticky-kit/dist/sticky-kit');

//var ssk = require('../node_modules/social-share-kit/dist/js/social-share-kit');
//var gatrack = require('./gatrack');
//var scrollstop = require('./scrollstop');
//var popper = require('popper.js');
//var unveil = require('./jquery.unveil');

global.lazyLoad = new LazyLoad({
    elements_selector: ".lazy",
    threshold: 50
    // ... more custom settings?
});

// Sticky
var make_sticky = function() {
    var el = $(".sticky");
    var window_width = $(window).width();
    if (window_width < 768) {
      el.trigger("sticky_kit:detach");
    } else {
        var offsetTop = el.data('offsetTop');
        //console.log('offsetTop', offsetTop, el.data('offset-top'), el.data('offset_top'));
        el.stick_in_parent({offset_top: offsetTop || 0, parent: '.sticky-parent', spacer: '.sticky-wrapper'});
    }
}
$(document).ready(make_sticky);
//$(window).resize(make_sticky);

/*
$(document).ready(function () {
    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return '';
    }
	function removeElement(elementId) {
		// Removes an element from the document
		var element = document.getElementById(elementId);
		element.parentNode.removeChild(element);
	}

    if (!readCookie('qfr')) 
    {
        setTimeout(function() {
            var id = 'amzn-ad';
            $('body').append('<img id="'+id+'" src="/amzn.jpg" style="visibility: hidden;" />'); 

            var c_name = 'qfr';
            var c_exp = 60 * 60 * 1000;
            var exdate = new Date();
            exdate.setTime(exdate.getTime() + c_exp); 
            var c_value = escape(true) +  "; expires=" + exdate.toUTCString();
            document.cookie = c_name + "=" + c_value;

            setTimeout(function() {
                //removeElement(document.getElementById(id));
                removeElement(id);
            }, 10000);
        }, 5000);
    }
});

*/
